import React from "react";
import Logo from '../../../icons/uae_dentist_logotypeLarge.png';
import './clinicnavbar.css'
import {
  Button,
  Navbar,
  Nav,
  Image,
} from "react-bootstrap";
import { LinkContainer } from 'react-router-bootstrap'
import { useHistory } from "react-router-dom";


export default function ClinicNavbar(props) {
    console.log(props)
    const clinicData = props.location.state; 
    // console.log(props.location.state.clinicData);
    let history = useHistory();
    function logout (){
        localStorage.removeItem("token");
        console.log(localStorage.getItem('token'))
        history.push('/')   
    }
    
    return (
    <div>
        <Navbar className="block-example border-bottom border-dark shadow p-0 bg-white " bg="light" expand="lg" style={{ borderColor: 'black'}}>
        
        <LinkContainer to="/">
        <Navbar.Brand>
            <Image className='mx-3'src={Logo} style={{width: "70px", height: "50px"}}></Image>
        </Navbar.Brand>
        </LinkContainer>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mr-auto">
            
            <LinkContainer to={{
                pathname: "/logged-in/calendar",
                state: clinicData 
            }}>
                <Nav.Link>Calendar</Nav.Link>
            </LinkContainer>
            
            <LinkContainer to={{
                pathname: '/logged-in/clinic-profile',
                state: clinicData
            }}
            >
                <Nav.Link>Clinic Profile</Nav.Link>
            </LinkContainer>

            <LinkContainer to={{
                pathname: '/logged-in/staff',
                state: clinicData
            }}>
                <Nav.Link>Staff</Nav.Link>
            </LinkContainer>

            <LinkContainer to={{
                pathname: "/logged-in/bookings",
                state: clinicData
            }}>
                <Nav.Link>Bookings</Nav.Link>
            </LinkContainer>

            <LinkContainer to={{
                pathname: "/logged-in/campaigns",
                state: clinicData
            }}>
                <Nav.Link>Campaigns</Nav.Link>
            </LinkContainer>

            <LinkContainer to={{
                pathname: "/logged-in/services",
                state: clinicData
            }}>
                <Nav.Link>Services</Nav.Link>
            </LinkContainer>

            <LinkContainer to={{
                pathname: "/logged-in/opening-hours",
                state: clinicData
            }}>
                <Nav.Link>Opening Hours</Nav.Link>
            </LinkContainer>

            <LinkContainer to={{
                pathname: "/logged-in/images-media",
                state: clinicData
            }}>
                <Nav.Link>Images & Media</Nav.Link>
            </LinkContainer>

            <LinkContainer to={{
                pathname: "/logged-in/account",
                state: clinicData
            }}>
                <Nav.Link>Account</Nav.Link>
            </LinkContainer>

            <LinkContainer to={{
                pathname: "/logged-in/view-clinic",
                state: clinicData
            }}>
                <Button variant="info mr-5">View Clinic</Button>
            </LinkContainer>

            </Nav>

            <Button onClick={logout} variant="danger">Sign out</Button>

            </Navbar.Collapse>
            </Navbar>

        </div>
    )
}